import Vue from 'vue'
import { initCore } from 'src/lib/init.js'
import BoundingBoxRepresentation from '/src/components/geospatial/BoundingBoxRepresentation.vue'
import { initItemPage } from 'src/lib/item-page'

initCore()
initItemPage()

Vue.component('bounding-box-representation', BoundingBoxRepresentation);
new Vue({
    el: '#vue-bounding-box-container',
    components: {
        'bounding-box-representation': BoundingBoxRepresentation
    }
})
// Need to re-init drop downs
$('.dropdown-toggle').dropdown()
